import { render } from "./Doctors.vue?vue&type=template&id=0a0364a2&ts=true"
import script from "./Doctors.vue?vue&type=script&lang=ts"
export * from "./Doctors.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__